module.exports = function(done, value){
  return {value: value, done: !!done};
};


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/core-js/modules/_iter-step.js
// module id = ../../../node_modules/core-js/modules/_iter-step.js
// module chunks = common